/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentEvaluationRpc
 */

/**
 *  Represents a segment identifier, which is an immutable identifier for a segment.
 *  It contains the segment type and the implementation object ID.
 *  Ideally you should never construct a {@link SegmentIdentifier} directly, and should treat it as indivisible unit, using only identifiers you receive from Segment APIs.
 */

export let ComHubspotSegmentModelsResponse;
(function (_ComHubspotSegmentModelsResponse) {})(ComHubspotSegmentModelsResponse || (ComHubspotSegmentModelsResponse = {}));
export let ComHubspotSegmentModelsResponseEvaluation;
(function (_ComHubspotSegmentModelsResponseEvaluation) {})(ComHubspotSegmentModelsResponseEvaluation || (ComHubspotSegmentModelsResponseEvaluation = {}));
export const evaluateUsingSnapshotDataRpc = {
  serviceName: 'com.hubspot.segment.rpc.SegmentEvaluationRpc',
  rpcName: 'evaluateUsingSnapshotData',
  auth: 'app',
  fingerprint: 'RoudrRvbY3A9ejuFfkPTuRDXwXcckRB3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const evaluateFilterBranchUsingSnapshotDataRpc = {
  serviceName: 'com.hubspot.segment.rpc.SegmentEvaluationRpc',
  rpcName: 'evaluateFilterBranchUsingSnapshotData',
  auth: 'app',
  fingerprint: 'rQxk5o4OBnI9ejuFfkPTuRDXwXcckRB3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};